var map = {
	"./App": 167,
	"./App.tsx": 167,
	"./app": 449,
	"./app.json": 449,
	"./assets/adaptive-icon.png": 601,
	"./assets/cart.png": 450,
	"./assets/cooking.gif": 451,
	"./assets/en.svg": 442,
	"./assets/favicon.png": 602,
	"./assets/fonts/Poppins/OFL.txt": 603,
	"./assets/fonts/Poppins/Poppins-Black.ttf": 452,
	"./assets/fonts/Poppins/Poppins-BlackItalic.ttf": 604,
	"./assets/fonts/Poppins/Poppins-Bold.ttf": 453,
	"./assets/fonts/Poppins/Poppins-BoldItalic.ttf": 605,
	"./assets/fonts/Poppins/Poppins-ExtraBold.ttf": 454,
	"./assets/fonts/Poppins/Poppins-ExtraBoldItalic.ttf": 606,
	"./assets/fonts/Poppins/Poppins-ExtraLight.ttf": 607,
	"./assets/fonts/Poppins/Poppins-ExtraLightItalic.ttf": 608,
	"./assets/fonts/Poppins/Poppins-Italic.ttf": 609,
	"./assets/fonts/Poppins/Poppins-Light.ttf": 455,
	"./assets/fonts/Poppins/Poppins-LightItalic.ttf": 610,
	"./assets/fonts/Poppins/Poppins-Medium.ttf": 456,
	"./assets/fonts/Poppins/Poppins-MediumItalic.ttf": 611,
	"./assets/fonts/Poppins/Poppins-Regular.ttf": 457,
	"./assets/fonts/Poppins/Poppins-SemiBold.ttf": 612,
	"./assets/fonts/Poppins/Poppins-SemiBoldItalic.ttf": 613,
	"./assets/fonts/Poppins/Poppins-Thin.ttf": 614,
	"./assets/fonts/Poppins/Poppins-ThinItalic.ttf": 615,
	"./assets/fr.svg": 443,
	"./assets/icon.png": 616,
	"./assets/icons/allergens/allergen_celery.png": 617,
	"./assets/icons/allergens/allergen_crustacena.png": 618,
	"./assets/icons/allergens/allergen_eggs.png": 619,
	"./assets/icons/allergens/allergen_fish.png": 620,
	"./assets/icons/allergens/allergen_lupin.png": 621,
	"./assets/icons/allergens/allergen_milk.png": 622,
	"./assets/icons/allergens/allergen_molluscs.png": 623,
	"./assets/icons/allergens/allergen_mustard.png": 624,
	"./assets/icons/allergens/allergen_peanut.png": 625,
	"./assets/icons/allergens/allergen_sesame.png": 626,
	"./assets/icons/allergens/allergen_soya.png": 627,
	"./assets/icons/allergens/allergen_sulphurdioxide.png": 628,
	"./assets/icons/allergens/allergen_treenut.png": 629,
	"./assets/icons/allergens/allergen_wheat.png": 630,
	"./assets/icons/clock.png": 447,
	"./assets/icons/phone.png": 446,
	"./assets/icons/plus.png": 275,
	"./assets/icons/pointer.png": 445,
	"./assets/loading.gif": 458,
	"./assets/logo/aji-logo.png": 440,
	"./assets/logo/shopnearby-logo.png": 441,
	"./assets/menu.png": 459,
	"./assets/pl.svg": 444,
	"./assets/splash.png": 631,
	"./babel.config": 460,
	"./babel.config.js": 460,
	"./package": 461,
	"./package.json": 461,
	"./src": 110,
	"./src/": 110,
	"./src/components/Addon": 194,
	"./src/components/Addon.tsx": 194,
	"./src/components/AddonsPopup": 195,
	"./src/components/AddonsPopup.tsx": 195,
	"./src/components/Address": 196,
	"./src/components/Address.tsx": 196,
	"./src/components/ArticleItem": 190,
	"./src/components/ArticleItem.tsx": 190,
	"./src/components/ArticlesList": 189,
	"./src/components/ArticlesList.tsx": 189,
	"./src/components/BreadCrumbs": 81,
	"./src/components/BreadCrumbs.tsx": 81,
	"./src/components/Cart": 73,
	"./src/components/Cart.tsx": 73,
	"./src/components/CartItemClient": 122,
	"./src/components/CartItemClient.tsx": 122,
	"./src/components/CartItemMarketplace": 197,
	"./src/components/CartItemMarketplace.tsx": 197,
	"./src/components/CartNumberItemsCircle": 118,
	"./src/components/CartNumberItemsCircle.tsx": 118,
	"./src/components/CartSummary": 121,
	"./src/components/CartSummary.tsx": 121,
	"./src/components/CategoriesDropDown": 185,
	"./src/components/CategoriesDropDown.tsx": 185,
	"./src/components/CategoriesList": 462,
	"./src/components/CategoriesList.tsx": 462,
	"./src/components/ChangePassword": 123,
	"./src/components/ChangePassword.tsx": 123,
	"./src/components/ClientHeader": 60,
	"./src/components/ClientHeader.tsx": 60,
	"./src/components/Copyright": 52,
	"./src/components/Copyright.tsx": 52,
	"./src/components/CustomerAddress": 198,
	"./src/components/CustomerAddress.tsx": 198,
	"./src/components/ErrorPopup": 199,
	"./src/components/ErrorPopup.tsx": 199,
	"./src/components/Footer": 51,
	"./src/components/Footer.tsx": 51,
	"./src/components/GalleryWithScroll": 200,
	"./src/components/GalleryWithScroll.tsx": 200,
	"./src/components/GenericProductDisplayItem": 151,
	"./src/components/GenericProductDisplayItem.tsx": 151,
	"./src/components/GenericRectangleProductDisplayItem": 103,
	"./src/components/GenericRectangleProductDisplayItem.tsx": 103,
	"./src/components/Home": 192,
	"./src/components/Home.tsx": 192,
	"./src/components/HomeHeader": 50,
	"./src/components/HomeHeader.tsx": 50,
	"./src/components/LanguagePicker": 191,
	"./src/components/LanguagePicker.tsx": 191,
	"./src/components/Login": 124,
	"./src/components/Login.tsx": 124,
	"./src/components/LoginUser": 463,
	"./src/components/LoginUser.tsx": 463,
	"./src/components/Menu": 126,
	"./src/components/Menu.tsx": 126,
	"./src/components/MenuEntry": 204,
	"./src/components/MenuEntry.tsx": 204,
	"./src/components/MobileHeader": 205,
	"./src/components/MobileHeader.tsx": 205,
	"./src/components/MyAddresses": 127,
	"./src/components/MyAddresses.tsx": 127,
	"./src/components/MyOrders": 128,
	"./src/components/MyOrders.tsx": 128,
	"./src/components/Option": 206,
	"./src/components/Option.tsx": 206,
	"./src/components/OptionGroup": 207,
	"./src/components/OptionGroup.tsx": 207,
	"./src/components/OptionPicker": 208,
	"./src/components/OptionPicker.tsx": 208,
	"./src/components/OptionsPopup": 209,
	"./src/components/OptionsPopup.tsx": 209,
	"./src/components/OrderPage": 210,
	"./src/components/OrderPage.tsx": 210,
	"./src/components/OrderPopup": 211,
	"./src/components/OrderPopup.tsx": 211,
	"./src/components/OrderStatusPopup": 212,
	"./src/components/OrderStatusPopup.tsx": 212,
	"./src/components/ProductCategory": 120,
	"./src/components/ProductCategory.tsx": 120,
	"./src/components/ProductInfo": 213,
	"./src/components/ProductInfo.tsx": 213,
	"./src/components/ProductListSortingSearch": 129,
	"./src/components/ProductListSortingSearch.tsx": 129,
	"./src/components/ProductPropositions": 215,
	"./src/components/ProductPropositions.tsx": 215,
	"./src/components/ProductsGallery": 188,
	"./src/components/ProductsGallery.tsx": 188,
	"./src/components/ProductsList": 94,
	"./src/components/ProductsList.tsx": 94,
	"./src/components/ProductsListRestaurant": 193,
	"./src/components/ProductsListRestaurant.tsx": 193,
	"./src/components/SortingWidget": 214,
	"./src/components/SortingWidget.tsx": 214,
	"./src/helpers/MediaQueryHelper": 53,
	"./src/helpers/MediaQueryHelper.tsx": 53,
	"./src/index": 110,
	"./src/index.tsx": 110,
	"./src/models/AccountModel": 171,
	"./src/models/AccountModel.tsx": 171,
	"./src/models/AddonModel": 116,
	"./src/models/AddonModel.tsx": 116,
	"./src/models/AddonPopupModel": 179,
	"./src/models/AddonPopupModel.tsx": 179,
	"./src/models/AddressModel": 74,
	"./src/models/AddressModel.tsx": 74,
	"./src/models/AllergenModel": 173,
	"./src/models/AllergenModel.tsx": 173,
	"./src/models/BreadCrumbModel": 70,
	"./src/models/BreadCrumbModel.tsx": 70,
	"./src/models/ClientModel": 172,
	"./src/models/ClientModel.tsx": 172,
	"./src/models/CustomerModel": 168,
	"./src/models/CustomerModel.tsx": 168,
	"./src/models/ErrorPopupModel": 181,
	"./src/models/ErrorPopupModel.tsx": 181,
	"./src/models/OptionGroupModel": 174,
	"./src/models/OptionGroupModel.tsx": 174,
	"./src/models/OptionModel": 115,
	"./src/models/OptionModel.tsx": 115,
	"./src/models/OptionPopupModel": 175,
	"./src/models/OptionPopupModel.tsx": 175,
	"./src/models/OrderItemAddonModel": 178,
	"./src/models/OrderItemAddonModel.tsx": 178,
	"./src/models/OrderItemModel": 176,
	"./src/models/OrderItemModel.tsx": 176,
	"./src/models/OrderItemOptionModel": 177,
	"./src/models/OrderItemOptionModel.tsx": 177,
	"./src/models/OrderModel": 32,
	"./src/models/OrderModel.tsx": 32,
	"./src/models/OrderPopupModel": 180,
	"./src/models/OrderPopupModel.tsx": 180,
	"./src/models/PriceModel": 54,
	"./src/models/PriceModel.tsx": 54,
	"./src/models/ProductCategoryModel": 114,
	"./src/models/ProductCategoryModel.tsx": 114,
	"./src/models/ProductModel": 85,
	"./src/models/ProductModel.tsx": 85,
	"./src/models/RootModel": 12,
	"./src/models/RootModel.tsx": 12,
	"./src/models/SearchStringModel": 182,
	"./src/models/SearchStringModel.tsx": 182,
	"./src/models/SortFilterModel": 99,
	"./src/models/SortFilterModel.tsx": 99,
	"./src/models/TranslatedTextModel": 49,
	"./src/models/TranslatedTextModel.tsx": 49,
	"./src/pages/AccountPage": 216,
	"./src/pages/AccountPage.tsx": 216,
	"./src/pages/AccountPageRestaurant": 217,
	"./src/pages/AccountPageRestaurant.tsx": 217,
	"./src/pages/ActivationAccountPageRestaurant": 218,
	"./src/pages/ActivationAccountPageRestaurant.tsx": 218,
	"./src/pages/CartPage": 219,
	"./src/pages/CartPage.tsx": 219,
	"./src/pages/CategoryPage": 220,
	"./src/pages/CategoryPage.tsx": 220,
	"./src/pages/ClientPage": 150,
	"./src/pages/ClientPage.tsx": 150,
	"./src/pages/CreateAccountPage": 221,
	"./src/pages/CreateAccountPage.tsx": 221,
	"./src/pages/CreateAccountPageRestaurant": 222,
	"./src/pages/CreateAccountPageRestaurant.tsx": 222,
	"./src/pages/ForgotPasswordPage": 223,
	"./src/pages/ForgotPasswordPage.tsx": 223,
	"./src/pages/ForgotPasswordPageRestaurant": 224,
	"./src/pages/ForgotPasswordPageRestaurant.tsx": 224,
	"./src/pages/HomePage": 184,
	"./src/pages/HomePage.tsx": 184,
	"./src/pages/LoginPage": 225,
	"./src/pages/LoginPage.tsx": 225,
	"./src/pages/LoginPageRestaurant": 226,
	"./src/pages/LoginPageRestaurant.tsx": 226,
	"./src/pages/ProductPage": 227,
	"./src/pages/ProductPage.tsx": 227,
	"./src/pages/ResetPasswordRestaurant": 228,
	"./src/pages/ResetPasswordRestaurant.tsx": 228,
	"./src/pages/SearchResultPage": 229,
	"./src/pages/SearchResultPage.tsx": 229,
	"./src/services/NetworkService": 29,
	"./src/services/NetworkService.tsx": 29,
	"./src/services/WebsocketService": 117,
	"./src/services/WebsocketService.tsx": 117,
	"./src/themes/AjiTheme": 87,
	"./src/themes/AjiTheme.tsx": 87,
	"./src/translations/Translations": 3,
	"./src/translations/Translations.tsx": 3,
	"./src/translations/engb": 147,
	"./src/translations/engb.tsx": 147,
	"./src/translations/frfr": 169,
	"./src/translations/frfr.tsx": 169,
	"./src/translations/plpl": 170,
	"./src/translations/plpl.tsx": 170,
	"./tsconfig": 464,
	"./tsconfig.json": 464,
	"./yarn.lock": 632
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 448;